import { FindUIInfo } from '../domain-models/ui-finder/find-ui-info';
import { GenericServiceRequest } from './generic-service-request';


export class FindUIInfoRequest extends GenericServiceRequest<FindUIInfo> {

}
